import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";

// Hardcoded by the build; bumped manually per release.
export const FRONTEND_VERSION = "3.0.0";

/**
 * Small typographic badge in the bottom-right corner of the landing page,
 * showing the running frontend and backend versions. Kept under 60% opacity
 * so it never competes with the actual content.
 */
export const VersionBadge = () => {
    const [backendVersion, setBackendVersion] = useState(null);

    useEffect(() => {
        api.get("/version")
            .then((r) => setBackendVersion(r.data?.version || "—"))
            .catch(() => setBackendVersion("—"));
    }, []);

    return (
        <div
            className="fixed bottom-3 right-3 z-30 text-[10px] font-body text-oth-ink3 opacity-60 leading-tight text-right pointer-events-none select-none"
            data-testid="version-badge"
            aria-hidden
        >
            <div data-testid="version-frontend">FE v{FRONTEND_VERSION}</div>
            <div data-testid="version-backend">BE v{backendVersion ?? "…"}</div>
        </div>
    );
};
